module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "session-logout",
      "href": "javascript:localStorage.clear(); sessionStorage.clear();window.location.href = '/Login'"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal bs-example-modal-sm",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true",
      "id": "sessionLogoutModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.user_lang.attention) + " "), _c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm.user_lang.expireWarning.replace('%', _vm.sessionExpiration - _vm.sessionWarning)))]), _vm._v(" "), _c('div', {
    attrs: {
      "clss": "row"
    }
  }, [_c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    staticStyle: {
      "background-color": "#ececec",
      "color": "#00524A"
    },
    attrs: {
      "href": "javascript:;",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.clickLogoutNo
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.user_lang.cancel))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "border-top": "0",
      "padding-top": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block btn-lg",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clickLogoutYes
    }
  }, [_vm._v("OK")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bs-example-modal-sm",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true",
      "id": "logoutMessageModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.user_lang.attention) + "  "), _c('i', {
    staticClass: "fa fa-lock"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm.user_lang.sessionTimedout))]), _vm._v(" "), _c('div', {
    attrs: {
      "clss": "row"
    }
  })])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2480fbbb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2480fbbb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/SessionTimeout.vue
// module id = 706
// module chunks = 1